export const fieldRequiredItems = ['item_code', 'item_name', 'sku', 'price_adjusted', 'qty', 'channel_order_item']
export const fieldRequiredInformation = ['channel_order', 'yomigana', 'name', 'address1', 'address2', 'phone', 'order_date', 'postal_code', 'terms', 'country']

export const fieldRomaji = ['sku', 'channel_order', 'phone', 'item_code', 'item_name', 'channel_order_item']
export const romajiNameOnlyCountries = ['HK', 'TW', 'SG', 'US']
export const romajiAddressOnlyCountries = ['HK', 'TW', 'SG', 'US']
export const yomiganaNotRequiredCountries = ['HK', 'TW', 'SG', 'US']
export const noPostalCodeCountries = ['HK'];
export const noPostalCodeValidationCountries = ['HK','TW','US', 'SG'];
export const GSTPaidFlagCountries = ['SG'];


// WEBPACK FOOTER //
// ./src/services/fieldRequired.js